import axios from '@/request';
import qs from 'qs';

export default {
  async getMessages(params: any) {
    return axios.get('message/list', { params });
  },
  async add(params: any) {
    return axios.post('message/add', qs.stringify(params));
  },
  async adminpush(params: any) {
    return axios.get('message/adminpush', { params })
  },
  async phrase(params: any) {
    return axios.get('message/phrase', { params })
  },
  async addphrase(params: any) {
    return axios.post('message/addphrase', qs.stringify(params))
  },
  async editphrase(params: any) {
    return axios.post('message/editphrase', qs.stringify(params))
  },
  async getphrase(params: any) {
    return axios.get('message/getphrase', { params })
  },
  async deletephrase(params: any) {
    return axios.post('message/deletephrase', qs.stringify(params))
  }
};

